import { cn } from "@/lib/utils";
import { BaseEntryValue } from "./BaseEntryValue";
import type { BaseEntryValueProps } from "./BaseEntryValue";

export interface YesNoEntryValueProps
	extends Omit<BaseEntryValueProps, "value"> {
	value: string | null;
}

export function YesNoEntryValue({
	value,
	inputLabel,
	size,
	...props
}: YesNoEntryValueProps) {
	return (
		<BaseEntryValue inputLabel={inputLabel} size={size} {...props}>
			<p
				className={cn(
					"capitalize",
					size === "sm" ? "text-sm" : size === "lg" ? "text-lg" : "text-base",
				)}
			>
				{value ?? "None"}
			</p>
		</BaseEntryValue>
	);
}
